import React from "react";
import styles from "./styles.m.css";

const checkAttr = (element, attr) =>
  !!(typeof element === "object" && element.hasOwnProperty(attr) && element[attr] && element[attr].length);

const ImageCaption = ({ element }) => {
  const [hasTitle, hasAttribution] = [checkAttr(element, "title"), checkAttr(element, "image-attribution")];
  if (hasTitle || hasAttribution) {
    return (
      <figcaption className={styles["image-caption"]}>
        {hasTitle && element["title"]}
        {hasAttribution && `  ( ${element["image-attribution"]} )`}
      </figcaption>
    );
  } else {
    return null;
  }
};

const HeroImageCaption = ({ storyData }) => {
  const [hasCaption, hasAttribution] = [checkAttr(storyData, "imageCaption"), checkAttr(storyData, "imageAttribution")];
  if (hasCaption || hasAttribution) {
    return (
      <figcaption className={styles["image-caption"]}>
        {hasCaption && storyData["imageCaption"]}
        {hasAttribution && `  ( ${storyData["imageAttribution"]} )`}
      </figcaption>
    );
  } else {
    return null;
  }
};

export { ImageCaption, HeroImageCaption };
export default ImageCaption;
